import dayjs from 'dayjs'

// Timeline/date helpers expect ISO 8601 strings (e.g. with Z for UTC). dayjs parses these
// and format() outputs in the user's local timezone.

const daysAgoMessages: { [key: number]: string } = {
  0: 'Today',
  1: 'Yesterday',
  2: 'Two days ago',
  3: 'Three days ago',
  4: 'Four days ago',
  5: 'Five days ago',
  6: 'Six days ago',
}

const isPlural = (count: number) => (count === 1 ? '' : 's')

const calculateTimeAgo = (lastLogin: string) => {
  if (!lastLogin) {
    return 'Never'
  }
  const currentTime = dayjs()
  const lastLoginTime = dayjs(lastLogin)

  if (currentTime.diff(lastLoginTime, 'year') !== 0) {
    const result = currentTime.diff(lastLoginTime, 'year')
    return `${result} Year${isPlural(result)} Ago`
  }
  if (currentTime.diff(lastLoginTime, 'month') !== 0) {
    const result = currentTime.diff(lastLoginTime, 'month')
    return `${result} Month${isPlural(result)} Ago`
  }
  if (currentTime.diff(lastLoginTime, 'week') >= 1) {
    const result = currentTime.diff(lastLoginTime, 'week')
    return `${result} Week${isPlural(result)} Ago`
  }

  return daysAgoMessages[currentTime.diff(lastLoginTime, 'day')]
}

const getFormatedDate = (time: string) => {
  return dayjs(time).format('dddd, MMMM D, YYYY') // '25/01/2019'
}

const formatTimelineDate = (time: string) => {
  const currentTime = dayjs()
  const timelineDate = dayjs(time)
  const diff = currentTime.startOf('day').diff(timelineDate.startOf('day'), 'day')
  if (diff == 0 || diff == 1) {
    return `${daysAgoMessages[diff]} ${getFormatedDate(time)} `
  }

  return getFormatedDate(time)
}

const getTimeFromDate = (date: string) => {
  return dayjs(date).format('h:mm A') // 3:44 PM (local time)
}

const formatTimeWithHours = (date: string) => {
  const dateFormated = dayjs(date).format('MMMM D, YYYY')
  const timeFormated = dayjs(date).format('h:mm A')

  return `${dateFormated} at ${timeFormated}`
}

export default {
  calculateTimeAgo,
  getFormatedDate,
  formatTimelineDate,
  getTimeFromDate,
  formatTimeWithHours,
}
